var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_grid_path: "/moderator/grid",
          order_column: "created_at",
          direction: "desc"
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function() {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID")
                ]),
                _c("vs-th", { key: "title", attrs: { "sort-key": "title" } }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.title")))
                ]),
                _c(
                  "vs-th",
                  {
                    key: "group_news_name",
                    attrs: { "sort-key": "group_news_name" }
                  },
                  [_vm._v(_vm._s(_vm.$t("group_news.group")))]
                ),
                _c(
                  "vs-th",
                  {
                    key: "comments_count",
                    staticClass: "no-sort",
                    attrs: { "sort-key": null }
                  },
                  [_vm._v("Comentários (total)")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "likes_count",
                    staticClass: "no-sort",
                    attrs: { "sort-key": null }
                  },
                  [_vm._v("Curtidas")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "views_count",
                    staticClass: "no-sort",
                    attrs: { "sort-key": null }
                  },
                  [_vm._v("Visualizações")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "comments_without_moderator_count",
                    staticClass: "no-sort",
                    attrs: { "sort-key": null }
                  },
                  [_vm._v("Comentários (sem moderador)")]
                )
              ]
            },
            proxy: true
          },
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  {
                    key: indextr,
                    class: {
                      "bg-light-warning":
                        tr.comments_without_moderator_count > 0
                    },
                    attrs: { data: tr }
                  },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")])
                    ]),
                    _c("vs-td", { key: "title", attrs: { width: "40%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.title))])
                    ]),
                    _c(
                      "vs-td",
                      { key: "group_news_name", attrs: { width: "10%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.group_news_name))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "comments_count", attrs: { width: "10%" } },
                      [
                        _c("div", [
                          _vm._v(" " + _vm._s(tr.comments_count) + " ")
                        ])
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "likes_count", attrs: { width: "10%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.data.like) + " ")])]
                    ),
                    _c(
                      "vs-td",
                      { key: "views_count", attrs: { width: "10%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.data.view) + " ")])]
                    ),
                    _c(
                      "vs-td",
                      {
                        key: "comments_without_moderator_count",
                        attrs: { width: "10%" }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "text-warning font-semibold":
                                tr.comments_without_moderator_count > 0
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(tr.comments_without_moderator_count) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletters_moderator.handling",
                                expression: "'newsletters_moderator.handling'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Detalhar e Moderar",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Detalhar e Moderar',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "CheckIcon" },
                            on: {
                              click: function($event) {
                                return _vm.moderate(props.data[indextr].id)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }